<template>
  <div>
    <div class="ego-button" :class="[use]">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    word: {
      type: String
    },
    use: {
      type: String,
      default: 'home'
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../../style/bulma/app.sass';

.ego-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 10px 18px;
  font-size: 22px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid $primary3;

  &.home {
    color: $primary3;
  }

  &.mobile {
    font-size: 18px;
    height: 44px;
  }

  &.bg {
    background: $primary3;
    color: #fff;
  }
}
</style>
